/*@flow*/
import L from 'leaflet';
import * as t from 'lib/t';

function lbounds(u) {
  return new L.LatLngBounds([[u[1], u[0]], [u[3], u[2]]]);
}

type TileJSON = {};

type Config = {
  url?: ?string,
  json?: ?TileJSON,
};

type Options = {
  format?:
    | 'png'
    | 'png32'
    | 'png64'
    | 'png128'
    | 'png256'
    | 'jpg70'
    | 'jpg80'
    | 'jpg90',
};

export const TileJSONLayer: any = L.TileLayer.extend({
  options: {
    format: 'png',
  },

  scalePrefix: '@2x.',

  initialize(config: ?Config, options: ?Options) {
    L.TileLayer.prototype.initialize.call(this, undefined, options);
    this._tilejson = {};
    this._loadTileJSON(config);
  },

  setUrl(url) {
    fetch(url)
      .then((res) => res.json())
      .then(this._setTileJSON.bind(this), (e) => console.error(e.stack));
    this.redraw();
  },

  _loadTileJSON({ url, json }) {
    if (url) {
      this.setUrl(url);
    } else if (json) {
      this._setTileJSON(json);
    }
  },

  _setTileJSON(json) {
    t.Object(json);
    let {
      tiles,
      minzoom,
      minZoom,
      maxzoom,
      maxZoom,
      attribution,
      bounds,
      scheme,
    } = json;

    L.extend(this.options, {
      tiles,
      attribution,
      minZoom: this.options.minZoom || minzoom || minZoom || 0,
      maxZoom: this.options.maxZoom || maxzoom || maxZoom || 22,
      tms: scheme === 'tms',
      bounds: bounds && lbounds(bounds),
    });
    this._tilejson = json;
    this.redraw();
    return this;
  },

  getTileJSON() {
    return this._tilejson;
  },

  getTileUrl(tilePoint) {
    let { tiles } = this.options;
    let { x, y, z } = tilePoint;
    let index = Math.floor(Math.abs(x + y) % tiles.length);
    let url = tiles[index];
    let templated;

    try {
      const s = this._getSubdomain(tilePoint);
      const o = { s, z, x, y };
      templated = L.Util.template(url, o);
    } catch (_) {} //eslint-disable-line

    if (!templated) return templated;
    return templated;
  },

  _update() {
    if (this.options.tiles) {
      return L.TileLayer.prototype._update.call(this);
    }
  },

  getBounds() {
    return this.options.bounds;
  },

  setOpacity(opacity) {
    this.options.opacity = opacity;
    if (this._map) {
      this._updateOpacity();
    }
    return this;
  },
});

export function tileJSON(config: Config, options?: Options): any {
  return new TileJSONLayer(config, options);
}

export default tileJSON;
